import React from 'react'
import Styles from './IntegrationSuccessModal.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { SettingScreen } from 'components/Settings/types'
import { PLATFORM_DISPLAY_NAMES } from 'utils/platformDisplayNames'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { generatePath } from 'react-router-dom'
import { BRAND_PLAN_PATH } from 'paths'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { getOrigin } from 'utils/location'

type Props = {
  integration: ExternalIntegration
  onClose: (options?: { openSettingScreen?: SettingScreen }) => void
  requiredFieldName?: string | null
}

export const AutopilotInfo = ({ integration, onClose, requiredFieldName = null }: Props): React.ReactElement => {
  const workspace = useCurrentWorkspace()
  const workspaceId = useCurrentWorkspaceId()
  const isAutopilot = workspace?.is_virtual_marketer
  const showAutopilotInfo = isAutopilot && workspace.is_virtual_marketer_onboarding_completed

  if (!showAutopilotInfo) {
    return <></>
  }

  const integrationName = PLATFORM_DISPLAY_NAMES[integration.provider]
  return (
    <>
      <div className={Styles.description}>
        <Text>
          {`Blaze will automatically post all of your ${integrationName} content to your ${integration.name} account going
              forward. You can delete or unschedule posts on your calendar.`}
        </Text>
      </div>
      <div className={Styles.description}>
        <Text>
          Don't want autopost? Update it in{' '}
          <button
            className={Styles.settingsButton}
            onClick={() => {
              const brandPlanUrl = `${getOrigin()}${generatePath(BRAND_PLAN_PATH, { workspaceId })}`
              window.open(brandPlanUrl, '_blank', 'noopener,noreferrer')
            }}
          >
            <Text color="var(--selected-fill)">Settings</Text>
          </button>
        </Text>
      </div>
    </>
  )
}
